module.exports = __webpack_public_path__ + "img/1723598579262-image.jpg.fb2e2f0f.webp";